'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/querystring/index.js
// module id = 258
// module chunks = 0